const en: Record<string, string> = {
  // Navbar
  nav_inicio: 'Home',
  nav_sobre: 'About Us',
  nav_que: 'What We Do',
  nav_productos: 'Products',
  nav_contacto: 'Contact',
  lang_switch: 'ES',

  // Hero
  hero_title: 'Oil packaging and distribution with quality and safety',
  hero_btn_products: 'View products',
  hero_btn_info: 'Request information',

  // About
  about_label: 'About Us',
  about_title: 'Committed to',
  about_title_accent: 'operational quality',
  about_p1: 'Merandia is a company dedicated to the packaging, storage, and distribution of palm and soybean oils. Our activity focuses on ensuring that each product reaches the customer in optimal conditions, meeting the highest standards of food safety and traceability.',
  about_p2: 'We have specialized facilities for the safe handling of oils in volume, applying rigorous quality control protocols at every stage of the logistics process: reception, packaging, storage, and dispatch.',
  about_feat1: 'Certified quality control',
  about_feat2: 'National distribution',
  about_feat3: 'Specialized storage',
  about_feat4: 'Full traceability',

  // Process
  process_label: 'Our Operations',
  process_title: 'What do we do?',
  process_subtitle: 'We specialize in three key activities that ensure oil reaches your business in perfect condition',
  process_service: 'Service',

  process_1_title: 'Packaging',
  process_1_desc: 'We package palm and soybean oils in various presentations: 250ml, 430ml, 500ml, 830ml, 900ml, 1L, 9L bottles and 20L jugs, under strict hygiene and food safety protocols.',
  process_1_d1: 'High-capacity packaging lines',
  process_1_d2: 'Seal integrity and weight control',
  process_1_d3: 'Labeling per national regulations',
  process_1_d4: 'Traceability per production batch',

  process_2_title: 'Storage',
  process_2_desc: 'We have climate-controlled warehouses suitable for the safe handling of bulk oils, with temperature, humidity, and certified sanitary condition controls.',
  process_2_d1: 'Temperature-controlled warehouses',
  process_2_d2: 'FIFO system for inventory rotation',
  process_2_d3: 'Continuous condition monitoring',
  process_2_d4: 'Bulk storage capacity',

  process_3_title: 'Distribution',
  process_3_desc: 'We distribute our products to distributors, retailers, supermarkets, and wholesalers throughout Honduras, ensuring timely delivery and proper transport conditions.',
  process_3_d1: 'Nationwide coverage in Honduras',
  process_3_d2: 'Suitable transport fleet',
  process_3_d3: 'Order logistics tracking',
  process_3_d4: 'Distribution to wholesalers and retailers',

  // Stats / Why us
  stats_label: 'Our Strengths',
  stats_title: 'Why choose us?',
  stats_subtitle: 'We are a reliable partner for distributors and businesses that need quality-guaranteed oil supply',

  stats_1_value: 'Quality',
  stats_1_label: 'Guaranteed',
  stats_1_desc: 'Each batch goes through rigorous quality controls before dispatch, ensuring the product meets current food regulations.',

  stats_2_value: 'Regulatory',
  stats_2_label: 'Compliance',
  stats_2_desc: 'We operate under strict food safety regulations, with documented and traceable processes at every stage of our operational chain.',

  stats_3_value: 'Logistics',
  stats_3_label: 'Efficiency',
  stats_3_desc: 'Our operational capacity allows us to respond to orders swiftly, ensuring timely deliveries in optimal conditions nationwide.',

  stats_feat1: 'Nationwide coverage in Honduras',
  stats_feat2: 'Palm and soybean oils',
  stats_feat3: 'Multiple presentations',
  stats_feat4: 'Direct commercial support',

  // Products
  products_label: 'Catalog',
  products_title: 'Our Products',
  products_subtitle: 'Explore our brand portfolio and available presentations for distribution',
  products_all_brands: 'All brands',
  products_presentations: 'Presentations',
  products_available: 'Available in',
  products_request_btn: 'Request information',
  products_view_btn: 'View detail',
  products_close: 'Close',
  products_vegetal: 'Vegetable Oil',
  products_soya: 'Soybean Oil',
  products_palma: 'Palm Olein',

  // Alimorca brand
  brand_alimorca_name: 'Alimorca',
  brand_alimorca_desc: 'Soybean oil recognized by the public across its range of sizes, from the family bottle to the industrial bucket.',
  alimorca_1_name: 'Alimorca Soybean Oil 430ml',
  alimorca_1_pres: '430ml',
  alimorca_2_name: 'Alimorca Soybean Oil 500ml',
  alimorca_2_pres: '500ml',
  alimorca_3_name: 'Alimorca Soybean Oil 750ml',
  alimorca_3_pres: '750ml',
  alimorca_4_name: 'Alimorca Soybean Oil 828ml',
  alimorca_4_pres: '828ml',
  alimorca_5_name: 'Alimorca Soybean Oil 900ml',
  alimorca_5_pres: '900ml',
  alimorca_6_name: 'Alimorca Soybean Oil 1000ml',
  alimorca_6_pres: '1000ml',
  alimorca_7_name: 'Alimorca Soybean Oil 9L',
  alimorca_7_pres: '9L',
  alimorca_8_name: 'Alimorca Soybean Oil 18L',
  alimorca_8_pres: '18L',
  alimorca_p1_name: 'Alimorca Palm Olein 430ml',
  alimorca_p1_pres: '430ml',
  alimorca_p2_name: 'Alimorca Palm Olein 500ml',
  alimorca_p2_pres: '500ml',
  alimorca_p3_name: 'Alimorca Palm Olein 750ml',
  alimorca_p3_pres: '750ml',
  alimorca_p4_name: 'Alimorca Palm Olein 828ml',
  alimorca_p4_pres: '828ml',
  alimorca_p5_name: 'Alimorca Palm Olein 900ml',
  alimorca_p5_pres: '900ml',
  alimorca_p6_name: 'Alimorca Palm Olein 1000ml',
  alimorca_p6_pres: '1000ml',
  alimorca_p7_name: 'Alimorca Palm Olein 9L',
  alimorca_p7_pres: '9L',
  alimorca_p8_name: 'Alimorca Palm Olein 18L',
  alimorca_p8_pres: '18L',

  // Delsarten brand
  brand_del_name: 'Delsarten',
  brand_del_desc: 'Soybean oil in the same sizes as Alimorca, under the Delsarten brand.',
  del_1_name: 'Delsarten Soybean Oil 430ml',
  del_1_pres: '430ml',
  del_2_name: 'Delsarten Soybean Oil 500ml',
  del_2_pres: '500ml',
  del_3_name: 'Delsarten Soybean Oil 750ml',
  del_3_pres: '750ml',
  del_4_name: 'Delsarten Soybean Oil 828ml',
  del_4_pres: '828ml',
  del_5_name: 'Delsarten Soybean Oil 900ml',
  del_5_pres: '900ml',
  del_6_name: 'Delsarten Soybean Oil 1000ml',
  del_6_pres: '1000ml',
  del_7_name: 'Delsarten Soybean Oil 9L',
  del_7_pres: '9L',
  del_8_name: 'Delsarten Soybean Oil 18L',
  del_8_pres: '18L',
  del_p1_name: 'Delsarten Palm Olein 430ml',
  del_p1_pres: '430ml',
  del_p2_name: 'Delsarten Palm Olein 500ml',
  del_p2_pres: '500ml',
  del_p3_name: 'Delsarten Palm Olein 750ml',
  del_p3_pres: '750ml',
  del_p4_name: 'Delsarten Palm Olein 828ml',
  del_p4_pres: '828ml',
  del_p5_name: 'Delsarten Palm Olein 900ml',
  del_p5_pres: '900ml',
  del_p6_name: 'Delsarten Palm Olein 1000ml',
  del_p6_pres: '1000ml',
  del_p7_name: 'Delsarten Palm Olein 9L',
  del_p7_pres: '9L',
  del_p8_name: 'Delsarten Palm Olein 18L',
  del_p8_pres: '18L',

  product_btn: 'Request information',

  // CTA
  cta_quality_label: 'Operational quality',
  cta_quality_title: 'Packaging\nto industrial\nstandards',
  cta_title: 'Do you need a reliable supplier?',
  cta_desc: 'Contact us and tell us about your business needs. We are ready to serve distributors, retailers, and wholesalers.',
  cta_btn_info: 'Request information',
  cta_btn_products: 'View products',

  // Sectors
  sectors_label: 'Market',
  sectors_title: 'Who do we supply?',
  sectors_subtitle: 'We serve different sectors of the Honduran market with supply solutions tailored to each need',

  sector_1_title: 'Wholesale Distributors',
  sector_1_desc: 'We supply distributors who serve multiple points of sale at regional and national level.',

  sector_2_title: 'Supermarkets & Stores',
  sector_2_desc: 'We supply supermarkets, convenience stores, and grocery businesses with presentations suitable for retail.',

  sector_3_title: 'Food Industry',
  sector_3_desc: 'We supply bulk oil and large-format presentations to food sector companies that use it as an ingredient.',

  sector_4_title: 'Restaurants & Hotels',
  sector_4_desc: 'We serve the food and hospitality sector with 20L jug presentations for intensive use.',

  sector_5_title: 'Wholesalers',
  sector_5_desc: 'We work with wholesalers that require high product volumes under specific commercial terms.',

  sector_6_title: 'Institutions & Programs',
  sector_6_desc: 'We supply social programs, public and private institutions with oils meeting required specifications.',

  sectors_cta_title: "Is your business not on the list?",
  sectors_cta_desc: 'Contact us and evaluate with our commercial team if we can meet your oil supply needs',
  sectors_cta_btn: 'Request information',

  // Location
  location_label: 'Our Location',
  location_title: 'Our Location',
  location_subtitle: 'Find us easily and get in touch',
  location_address_label: 'Address',
  location_email_label: 'Email',
  location_phone_label: 'Phone',
  location_desc: 'Visit us or contact us to learn more about our products. We are available to provide you with the best service.',
  location_btn: 'View on Google Maps',

  // Contact
  contact_title: 'Contact Us',
  contact_subtitle: 'We are here to help you',
  contact_name: 'Name',
  contact_email: 'Email Address',
  contact_phone: 'Phone',
  contact_message: 'Message',
  contact_submit: 'Send Message',
  contact_sending: 'Sending...',
  contact_success: 'Message sent successfully! We will get in touch soon.',
  contact_error: 'An error occurred while sending. Please try again.',
  contact_chars: 'Maximum 500 characters',

  // Footer
  footer_tagline: 'Packaging, storage, and distribution of quality oils in Honduras.',
  footer_products_title: 'Products',
  footer_palm: 'Palm Oil',
  footer_soya: 'Soybean Oil',
  footer_presentations: 'Presentations',
  footer_company_title: 'Company',
  footer_about: 'About Us',
  footer_what: 'What We Do',
  footer_why: 'Why Choose Us',
  footer_contact_title: 'Contact',
  footer_sectors: 'Sectors served',
  footer_copyright: '© 2025 Merandia. All rights reserved.',
  footer_privacy: 'Privacy',
  footer_terms: 'Terms',
};

export default en;
